<template>
  <div class="container_self">
    <h3>短剧模板</h3>

    <el-form
      label-width="120px"
      :model="templateForm"
      size="mini"
      class="articleFrom"
      width="80%"
    >
      <el-form-item label="域名">
        <el-select v-model="templateForm.domain" @change="domainChange">
          <el-option
            v-for="(item, index) in domainlist"
            :value="item.dm"
            :label="item.dm"
            :key="index"
          ></el-option>
        </el-select>
        <el-button
          size="mini"
          type="warning"
          style="margin-left: 15px"
          @click="checkTemplate"
          >查询</el-button
        >
        <el-button size="mini" type="success" style="margin-left: 15px" @click="makePage"
          >生成页面</el-button
        >
      </el-form-item>
      <el-form-item label="类型">
        <el-select v-model="templateForm.item" @change="typeChange">
          <el-option
            v-for="(item, index) in items"
            :value="item.value"
            :label="item.label"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="配置项">
        <el-input
          @keydown.enter.prevent
          type="textarea"
          :autosize="{ minRows: 20, maxRows: 400 }"
          placeholder="请输入内容"
          v-model="templateForm.value"
        >
        </el-input>
      </el-form-item>
      <el-form-item label="描述">
        <el-input placeholder="请输入描述" v-model="templateForm.description"></el-input>
      </el-form-item>
      <el-form-item style="width: 100%"
        ><el-button type="primary" style="float: right" @click="submit"
          >提交</el-button
        ></el-form-item
      >
    </el-form>
  </div>
</template>

<script>
import { axiosGet, axiosPost } from "@/assets/ajaxFn";
export default {
  data() {
    return {
      templateForm: {
        value: "",
        description: "",
        item: "movie_index_template",
        domain: "",
      },
      domainlist: [],
      items: [
        {
          value: "movie_index_template",
          label: "短剧模板首页",
        },
        {
          value: "movie_list_template",
          label: "短剧模板列表页",
        },
        {
          value: "movie_info_template",
          label: "短剧模板详情页",
        },
      ],
    };
  },
  methods: {
    domainChange() {
      this.templateForm = {
        value: "",
        description: "",
        item: "movie_index_template",
        domain: this.templateForm.domain,
      };
    },
    typeChange() {
      if (!this.templateForm.domain) {
        return false;
      }
      this.checkTemplate();
    },
    submit() {
      if (this.templateForm.value) {
        axiosPost("/api/cms/config/update", this.templateForm, "JSON").then((res) => {
          if (res.code == 0) {
            this.$message({ message: "更新成功", type: "success" });
          }
        });
      } else {
        this.$message({ message: "请填写内容", type: "error" });
      }
    },
    checkTemplate() {
      axiosGet("/api/cms/config/item", {
        domain: this.templateForm.domain,
        item: this.templateForm.item,
      }).then((res) => {
        if (res.code == 0) {
          if (res.data.id) {
            this.templateForm = res.data;
          }
        }
      });
    },
    makePage() {
      if (this.templateForm.domain && this.templateForm.item && this.templateForm.value) {
        axiosPost(
          "/api/movie/make/all",
          { domain: this.templateForm.domain },
          "JSON"
        ).then((res) => {
          if (res.code == 0) {
            this.$message({ message: "生成成功", type: "success" });
          }
        });
      } else {
        this.$message({ message: "请选择域名、并确认已配置", type: "error" });
      }
    },
  },
  mounted() {
    // /api/cms/article/domains
    axiosGet("/api/domains/list?dmType=3").then((res) => {
      if (res.code == 0) {
        this.domainlist = res.data.records.length ? res.data.records : [];
        console.log(this.domainlist);
      }
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/view/videoManager/videoTemplate.vue